(function () {
  'use strict';

  var Utils = window.TDCUtils;
  var root = document.documentElement;

  var scrim = document.getElementById('scrim');
  var currentOverlay = null;
  var lastFocus = null;

  function setExpanded(id, val) {
    document.querySelectorAll('[data-open="' + id + '"][aria-expanded]').forEach(function (b) {
      b.setAttribute('aria-expanded', val);
    });
  }

  function openOverlay(id, opener) {
    if (currentOverlay && currentOverlay.id !== id) closeOverlay(true);

    var el = document.getElementById(id);
    if (!el) return;

    if (id === 'cart' && window.TDCCart && window.TDCCart.fetch) {
      window.TDCCart.fetch();
    }
    if (id === 'search' && window.TDCSearch && window.TDCSearch.render) {
      var searchInput = document.getElementById('search-input');
      if (searchInput) window.TDCSearch.render(searchInput.value || '');
    }

    lastFocus = opener || document.activeElement;
    currentOverlay = el;
    el.classList.add('is-open');
    if (scrim) scrim.classList.add('is-on');
    root.classList.add('is-locked');
    setExpanded(id, 'true');

    window.setTimeout(function () {
      var target = id === 'search' ? document.getElementById('search-input') : Utils.getFocusableElements(el)[0];
      if (target) target.focus({ preventScroll: true });
    }, 80);

    var cleanup = Utils.trapFocus(el);
    el._cleanupFocus = cleanup;
  }

  function closeOverlay(silent) {
    if (!currentOverlay) return;
    if (currentOverlay._cleanupFocus) currentOverlay._cleanupFocus();
    currentOverlay.classList.remove('is-open');
    setExpanded(currentOverlay.id, 'false');
    currentOverlay = null;

    if (silent) return;
    if (scrim) scrim.classList.remove('is-on');
    root.classList.remove('is-locked');
    if (lastFocus && document.body.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openOverlay(opener.getAttribute('data-open'), opener);
      return;
    }
    if (e.target.closest('[data-close]') && currentOverlay) closeOverlay();
  });

  if (scrim) scrim.addEventListener('click', function () { closeOverlay(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (currentOverlay) closeOverlay();
      else if (window.TDCHeader && window.TDCHeader.close) window.TDCHeader.close(true);
    }
  });

  window.TDCOverlay = {
    open: openOverlay,
    close: closeOverlay
  };
})();